$.fancybox.defaults.touch = false;
